import { Link } from "react-router-dom";
import { Linkedin, Instagram, MessageCircle, Mail, Phone } from "lucide-react";

const BadgePill = ({ children, testId }) => (
  <span
    data-testid={testId}
    className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-white/10 border border-white/20 text-xs font-semibold tracking-wide"
  >
    <span className="h-1.5 w-1.5 rounded-full bg-bee-honey" />
    {children}
  </span>
);

export default function Footer() {
  return (
    <footer className="bg-[hsl(var(--bee-teal-dark))] text-white" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <img
              src="/logo.png"
              alt="WorkingBees Global recruitment agency logo"
              className="h-40 w-40 sm:h-44 sm:w-44 object-contain rounded-2xl bg-white p-2 shadow-lg"
              data-testid="footer-logo"
            />
            <p className="mt-4 text-sm text-white/70 max-w-xs">
              Connecting Talent. Delivering Excellence. ISO &amp; MSME certified recruitment and IT consulting partner.
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              <BadgePill testId="footer-badge-iso">ISO Certified</BadgePill>
              <BadgePill testId="footer-badge-msme">MSME Certified</BadgePill>
            </div>
          </div>

          <div>
            <div className="text-xs uppercase tracking-[0.18em] text-white/60 mb-4">Quick Links</div>
            <ul className="space-y-2.5 text-sm">
              <li><a href="/#home" className="hover:text-bee-honey transition" data-testid="footer-link-home">Home</a></li>
              <li><a href="/#about" className="hover:text-bee-honey transition" data-testid="footer-link-about">About</a></li>
              <li><a href="/#services" className="hover:text-bee-honey transition" data-testid="footer-link-services">Services</a></li>
              <li><Link to="/jobs" className="hover:text-bee-honey transition" data-testid="footer-link-jobs">Jobs</Link></li>
              <li><a href="/#candidates" className="hover:text-bee-honey transition" data-testid="footer-link-candidates">Candidates</a></li>
              <li><a href="/#contact" className="hover:text-bee-honey transition" data-testid="footer-link-contact">Contact</a></li>
            </ul>
          </div>

          <div>
            <div className="text-xs uppercase tracking-[0.18em] text-white/60 mb-4">Reach Us</div>
            <ul className="space-y-3 text-sm text-white/80">
              <li className="flex items-start gap-2.5">
                <Mail className="h-4 w-4 mt-0.5 flex-shrink-0" />
                <a href="mailto:info@workingbees.net" className="hover:text-bee-honey">info@workingbees.net</a>
              </li>
              <li className="flex items-start gap-2.5">
                <Phone className="h-4 w-4 mt-0.5 flex-shrink-0" />
                <a href="tel:+919011579799" className="hover:text-bee-honey">+91 90115 79799</a>
              </li>
            </ul>
          </div>

          <div>
            <div className="text-xs uppercase tracking-[0.18em] text-white/60 mb-4">Follow</div>
            <div className="flex gap-2">
              <a href="#" data-testid="footer-social-linkedin" aria-label="LinkedIn" className="h-10 w-10 inline-flex items-center justify-center rounded-full border border-white/20 hover:bg-bee-orange hover:border-bee-orange transition"><Linkedin className="h-4 w-4" /></a>
              <a href="#" data-testid="footer-social-instagram" aria-label="Instagram" className="h-10 w-10 inline-flex items-center justify-center rounded-full border border-white/20 hover:bg-bee-orange hover:border-bee-orange transition"><Instagram className="h-4 w-4" /></a>
              <a href="#" data-testid="footer-social-whatsapp" aria-label="WhatsApp" className="h-10 w-10 inline-flex items-center justify-center rounded-full border border-white/20 hover:bg-bee-orange hover:border-bee-orange transition"><MessageCircle className="h-4 w-4" /></a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/60">
          <div>© 2026 WorkingBees Global. All Rights Reserved.</div>
          <div className="flex gap-5">
            <a href="#" className="hover:text-white">Privacy Policy</a>
            <a href="#" className="hover:text-white">Terms of Use</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
